import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconGameController({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path
					id="a"
					d="M6.316 3.158v2.085h2.122v1.093H6.316V8.42H5.28V6.336H3.158V5.243H5.28V3.158zm8.437 3.178a1.014 1.014 0 0 1 1.036 1.043 1.014 1.014 0 0 1-1.036 1.042q-.444 0-.79-.298a1.01 1.01 0 0 1-.295-.745q0-.447.32-.744.322-.298.765-.298m-2.121-3.178A1.014 1.014 0 0 1 13.668 4.2a1.014 1.014 0 0 1-1.036 1.042A1.014 1.014 0 0 1 11.596 4.2a1.014 1.014 0 0 1 1.036-1.042"
				/>
			</defs>
			<g fill="none" fillRule="nonzero" transform="translate(2 5)">
				<path
					fill="#CD0400"
					d="M17.326 14.737q1.22 0 2.026-.85t.61-1.997l-1.123-7.485q-.243-1.378-1.415-2.365a4.05 4.05 0 0 0-2.684-.987H5.27q-1.561 0-2.733.964-1.171.965-1.367 2.388L.05 11.89q0 .046-.025.183l-.008.052a1 1 0 0 0-.016.132q0 1.056.757 1.768.756.712 1.879.712t1.903-.735l2.343-2.204h6.247l2.343 2.204q.78.735 1.854.735"
				/>
				<path
					fill="#FFF"
					d="M17.326 13.684q1.22 0 2.026-.85t.61-1.997l-1.123-7.485q-.243-1.378-1.415-2.365A4.05 4.05 0 0 0 14.74 0H5.27Q3.71 0 2.538.964 1.367 1.93 1.17 3.352L.05 10.837q0 .046-.025.184l-.008.051a1 1 0 0 0-.016.133q0 1.056.757 1.767.756.712 1.879.712t1.903-.735l2.343-2.204h6.247l2.343 2.204q.78.735 1.854.735"
				/>
				<use xlinkHref="#a" fill="#CD0400" />
			</g>
		</svg>
	);
}
